import { memo } from 'react';
import useStoreAndLanguageParams from '../../core/hooks/useStoreAndLanguageParams';
import useCurrentStockOnlyFlag from '../hooks/useCurrentStockOnlyFlag';
import useStockMessage from '../hooks/useStockMessage';
import type {
    StockQuantity,
    FutureStockQuantities,
    ProductOrderRestriction,
} from '../types';
import getGeneralStockStatuses from '../util/getGeneralStockStatuses';
import ProductStockIndicatorContent from './ProductStockIndicatorContent';

const GeneralStockIndicator = ({
    location,
    messageStyle,
    branchName,
    hideBranchesWithoutAvailability = false,
    hideBranchCode = false,
    isSecondaryBranch = false,
    stock,
    futureStock,
    restriction = [],
    loading = false,
}: {
    location: string;
    messageStyle: 'left' | 'right' | 'tooltip' | 'none';
    branchName: string;
    hideBranchesWithoutAvailability?: boolean;
    hideBranchCode?: boolean;
    isSecondaryBranch?: boolean;
    stock: StockQuantity[];
    futureStock: FutureStockQuantities[];
    restriction?: ProductOrderRestriction[];
    loading?: boolean;
}) => {
    const { store } = useStoreAndLanguageParams();
    const currentStockOnly = useCurrentStockOnlyFlag();

    const statuses = getGeneralStockStatuses({
        store,
        stock,
        futureStock,
        currentStockOnly,
        restriction,
    });

    const stockMessage = useStockMessage({
        stock,
        futureStock,
        restriction,
    });

    const restrictionId = restriction[0]?.restrictionId;

    return (
        <ProductStockIndicatorContent
            restrictionId={restrictionId}
            loading={loading}
            branchName={branchName}
            status={statuses.status}
            isMixed={statuses.isMixed}
            messageStyle={messageStyle}
            stockMessage={stockMessage}
            location={location}
            hideBranchesWithoutAvailability={hideBranchesWithoutAvailability}
            hideBranchCode={hideBranchCode}
            isSecondaryBranch={isSecondaryBranch}
        />
    );
};

export default memo(GeneralStockIndicator);
